import { useRef } from "react";
import type { Step } from "../../../shared/types";
import StepSettings from "./StepSettings";
import { MEDIA_ACCEPT, type StepActions } from "./useStepActions";

/** Screen-level settings, shown in the inspector under the tool's own panel. */
export function StepPanel({ step }: { step: Step }) {
  return (
    <>
      <StepSettings step={step} />
    </>
  );
}

/** Pinned to the bottom of the inspector: the destructive and structural actions for the screen. */
export function StepActionsBar({ step, actions }: { step: Step; actions: StepActions }) {
  const fileRef = useRef<HTMLInputElement>(null);
  return (
    <div className="insp-actions">
      <span className="spacer" />
      {!step.textCard && <button className="btn btn-sm" onClick={() => fileRef.current?.click()}>Replace media</button>}
      <input ref={fileRef} type="file" hidden accept={MEDIA_ACCEPT} onChange={(e) => { const f = e.target.files?.[0]; if (f) void actions.replace(step, f); e.target.value = ""; }} />
    </div>
  );
}
